import socketModule from './socket-module';

function connectToSocketServer(socketUrl, accessToken, logout) {
    socketModule.connectToServer({
        socketUrl,
        accessToken,
        logout
    });
}

function disconnectFromServer() {
    socketModule.disconnectFromServer();
}

function leaveAllRooms() {
    socketModule.leaveAllRooms();
}

function joinRooms(clientIds) {
    socketModule.joinClientRooms({
        clientIds
    });
}

function leaveRooms(clientIds) {
    socketModule.leaveRooms({
        clientIds
    });
}

export default {
    connectToSocketServer,
    disconnectFromServer,
    joinRooms,
    leaveRooms,
    leaveAllRooms
};
